const blackjackLoadPositions = [
  { floor: 0, x: -31, z: 23 },
  { floor: 0, x: 31, z: 15.5 },
  { floor: 0, x: 21, z: 0 },
  { floor: 0, x: -21, z: -6 },
  { floor: 0, x: -23, z: -13 },
  { floor: 0, x: -8, z: 23 },
  { floor: 0, x: 8, z: 23 },
  { floor: 1, x: 22, z: -16 },
  { floor: 1, x: 22, z: -1 },
  { floor: 1, x: -22, z: 14 },
  { floor: 1, x: 22, z: 21.5 },
  { floor: 1, x: -32, z: 0 },
  { floor: 1, x: -10, z: 33 },
] as const;

const mainPositions = {
  "casino/blackjack/main": { floor: 0, x: 0, z: 0 },
  "casino/poker/main": { floor: 0, x: -6.8, z: 0 },
  "casino/roulette/main": { floor: 0, x: 5.94, z: 0 },
} as const;

export type FloorPlanPosition = {
  floor: number;
  left: number;
  top: number;
};

// Matches the authored casino collision extents, with a small visual gutter.
const floorPlanBounds = { minX: -60, maxX: 60, minZ: -40, maxZ: 48 } as const;

export function environmentFloorPlanPosition(
  placementSlotId: string | null | undefined,
): FloorPlanPosition | null {
  if (!placementSlotId) return null;
  const main = mainPositions[placementSlotId as keyof typeof mainPositions];
  const match = placementSlotId.match(/^casino\/blackjack\/load-(\d{2})$/);
  const load = match ? blackjackLoadPositions[Number(match[1]) - 1] : undefined;
  const position = main ?? load;
  if (!position) return null;
  return {
    floor: position.floor,
    left:
      ((position.x - floorPlanBounds.minX) / (floorPlanBounds.maxX - floorPlanBounds.minX)) * 100,
    top:
      ((floorPlanBounds.maxZ - position.z) / (floorPlanBounds.maxZ - floorPlanBounds.minZ)) * 100,
  };
}
